import { requireService, wrap } from '@repo/di-ez';
import { ChooseRow, SettingLineLight } from '@repo/go-icons';
import { ActionsBar, Tooltip } from '@repo/go-ui';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  extraTopItems?: ReactNode;
};

export const TrajectoryActionsBar = wrap(function TrajectoryActionsBar({ extraTopItems }: Props) {
  const { t } = useTranslation();
  const uiStore = requireService('trajectoryUiStore');

  return (
    <ActionsBar>
      <ActionsBar.TopBar>
        {extraTopItems}
        <Tooltip placement="left" title={t('Toolbar.toggleCheckboxes')} delay={400}>
          <ActionsBar.Item
            active={uiStore.isTableCheckboxesVisible}
            onClick={() => uiStore.setTableCheckboxesVisible(!uiStore.isTableCheckboxesVisible)}
          >
            <ChooseRow />
          </ActionsBar.Item>
        </Tooltip>
      </ActionsBar.TopBar>
      <ActionsBar.BottomBar>
        <Tooltip placement="left" title={t('Toolbar.settings')} delay={400}>
          <ActionsBar.Item active={uiStore.isTableSettingsOpen} onClick={() => uiStore.setTableSettingsOpen(true)}>
            <SettingLineLight />
          </ActionsBar.Item>
        </Tooltip>
      </ActionsBar.BottomBar>
    </ActionsBar>
  );
});
